import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { isNil } from 'lodash';
import { Modal } from 'lp-components';
import { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button, H1, P, REACT_APP_BUILDID_FETCH_INTERVAL, useInterval, fetchApplicationBuildId, forceRedirect, } from 'shared';
import * as applicationServerApiActions from 'application-server-api-actions';
import { selectors } from 'global-reducer';
function VersionChangeReporter({ applicationBuildId, redirectURL, getApplicationBuildId, }) {
    const [displayVersionModal, setDisplayVersionModal] = useState(false);
    const reloadApplication = () => {
        forceRedirect({ to: redirectURL });
    };
    const determineIfBuildIdChanged = useCallback(async () => {
        if (!applicationBuildId)
            return;
        const latestBuildId = await fetchApplicationBuildId();
        if (!isNil(latestBuildId) && latestBuildId !== applicationBuildId) {
            setDisplayVersionModal(true);
        }
    }, [applicationBuildId]);
    useEffect(() => {
        getApplicationBuildId();
    }, []);
    useInterval(determineIfBuildIdChanged, {
        interval: REACT_APP_BUILDID_FETCH_INTERVAL,
    });
    return (displayVersionModal && (_jsx(Modal, { className: "alert-modal", onClose: reloadApplication, preventClose: true, children: _jsxs(_Fragment, { children: [_jsx("header", { children: _jsx(H1, { children: "System Upgrade/Updated" }) }), _jsx(P, { children: "We apologize for the inconvenience, but we just released some updates to the dashboard that will require a page reload to take effect. Please click below to reload your dashboard." }), _jsx(Button, { type: "button", className: "button-primary-outline", onClick: reloadApplication, children: "Continue" })] }) })));
}
function mapStateToProps(state) {
    return {
        applicationBuildId: selectors.applicationBuildId(state),
    };
}
const mapDispatchToProps = {
    getApplicationBuildId: applicationServerApiActions.getApplicationBuildId,
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(VersionChangeReporter);
